export default __webpack_public_path__ + "static/media/loading.e834de00.gif";